import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { StoreService } from 'app/services';
import { PartnerMartLocationsMenuLevel3Enum } from '../../../partner-mart-locations-root/partner-mart-locations-root.component';
import moment from 'moment';
import { LegalDocumentTypeEnum } from '../../../../../../../models';

@Component({
    selector: 'legal-documents-update',
    templateUrl: './legal-documents-update.component.html',
    styleUrls: ['./legal-documents-update.component.scss'],
    providers: [MessageService]
})
export class LegalDocumentsUpdateComponent {

    constructor(private messageService: MessageService, private storeService: StoreService) {
    }

    public today: Date = new Date();
    public tomorrow: Date = new Date(this.today.getTime() + (24 * 60 * 60 * 1000));

    @Input()
    public store: any = {};

    @Input()
    public activeDocumentMenuItem: PartnerMartLocationsMenuLevel3Enum = PartnerMartLocationsMenuLevel3Enum.None;

    @Input()
    public onHide: () => void = () => { };

    public menuLevel3Enum = PartnerMartLocationsMenuLevel3Enum;

    public legalDocument: any = {};

    public loading: boolean = false;

    public showUpdateOnReviewPopup: boolean = false;

    public handleSideBarHide() {
        this.onHide();
    }

    updateDocument() {
        if (!this.legalDocument.DocumentImageUrl || !this.legalDocument.DocumentIssueDate ||
            !this.legalDocument.DocumentExpirationDate || !this.legalDocument.DocumentNumber) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Fill all required fields' });
            return;
        }
        const dto = {
            StoreId: this.store.Id,
            Documents: [{
                DocumentImageUrl: this.legalDocument.DocumentImageUrl,
                DocumentIssueDate: moment(this.legalDocument.DocumentIssueDate).format('YYYY-MM-DD'),
                DocumentExpirationDate: moment(this.legalDocument.DocumentExpirationDate).format('YYYY-MM-DD'),
                DocumentNumber: this.legalDocument.DocumentNumber,
                DocumentTypeId: this.activeDocumentMenuItem === PartnerMartLocationsMenuLevel3Enum.BIR2303 ? LegalDocumentTypeEnum.BIR2303 :
                    this.activeDocumentMenuItem === PartnerMartLocationsMenuLevel3Enum.BusinessPermit ? LegalDocumentTypeEnum.BusinessPermit : 0
            }]
        };
        this.loading = true;

        this.storeService.updateStoreLegalDocs(dto, this.messageService)
            .then(data => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.showUpdateOnReviewPopup = true;
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    public handleUploadClick(): void {
        document.getElementById('idImgInput')?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.legalDocument.DocumentImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public handleUpdateOnReviewPopupHide() {
        this.showUpdateOnReviewPopup = false;
        this.handleSideBarHide();
    }
}
